import { Mail } from "lucide-react";
import { InstagramIcon, TikTokIcon, WhatsAppIcon } from "./BrandIcons";
import { NAV, SITE, waLink } from "@/lib/site";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/5 bg-ws-panel pt-20">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 md:grid-cols-2 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <img src="/img/logo-lockup.webp" alt="WebStation" loading="lazy" className="logo-blend w-60" />
        <p className="mt-6 max-w-sm text-ws-text/90">WebStation — soluções digitais para o seu negócio.</p>
        <p className="mt-2 font-mono text-xs uppercase tracking-widest text-ws-lime">Desde 2020</p>
      </div>
      <div className="lg:col-span-3">
        <h3 className="font-mono text-xs uppercase tracking-widest text-ws-muted">Navegação</h3>
        <ul className="mt-5 space-y-2.5">
          {NAV.map((n) => (
            <li key={n.id}>
              <button data-testid={`footer-nav-${n.id}`} onClick={() => scrollToId(n.id)} className="text-sm text-ws-text/85 transition-colors hover:text-ws-lime">{n.label}</button>
            </li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-4">
        <h3 className="font-mono text-xs uppercase tracking-widest text-ws-muted">Contato</h3>
        <ul className="mt-5 space-y-3 text-sm">
          <li><a data-testid="footer-whatsapp" href={waLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-ws-text/85 transition-colors hover:text-ws-lime"><WhatsAppIcon size={17} /> WhatsApp: {SITE.whatsappDisplay}</a></li>
          <li><a data-testid="footer-email" href={`mailto:${SITE.email}`} className="flex items-center gap-3 text-ws-text/85 transition-colors hover:text-ws-lime"><Mail size={17} /> {SITE.email}</a></li>
        </ul>
        <h3 className="mt-8 font-mono text-xs uppercase tracking-widest text-ws-muted">Redes sociais</h3>
        <div className="mt-4 flex flex-col gap-3 text-sm">
          <a data-testid="footer-instagram" href={SITE.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-ws-text/85 transition-colors hover:text-ws-lime"><InstagramIcon size={17} /> Instagram — {SITE.instagramHandle}</a>
          <a data-testid="footer-tiktok" href={SITE.tiktok} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-ws-text/85 transition-colors hover:text-ws-lime"><TikTokIcon size={17} /> TikTok — {SITE.tiktokHandle}</a>
        </div>
      </div>
    </div>
    <div className="mx-auto mt-16 flex max-w-7xl flex-col gap-3 border-t border-white/5 px-5 py-8 text-xs text-ws-muted sm:flex-row sm:items-center sm:justify-between sm:px-8">
      <p data-testid="footer-copyright">© 2026 WebStation. Todos os direitos reservados.</p>
      <p className="font-mono">Sites · Aplicativos · Soluções digitais</p>
    </div>
    <p aria-hidden="true" className="pointer-events-none -mb-[3vw] select-none text-center font-display text-[12vw] font-semibold leading-none tracking-tighter text-white/[0.03]">
      WEBSTATION
    </p>
  </footer>
);
